import moment from 'moment';
import React from 'react'; 
  
// Creating the context object and passing the default values. 
const filterContext = React.createContext({customerId : 0, warehouseId:0, date:[moment(new Date(), "YYYY-MM-DD").add(-20,"d"), moment(new Date( ), "YYYY-MM-DD")]}); 
  
export default filterContext;